<template>
  <div class="container">
    <div class="card-view">
      <h2>{{ `${user.first_name}'s ${$t('text.cards')}` }}</h2>
      <add-card></add-card>
    </div>
  </div>
</template>

<script>
import {AddCard} from "./components";
import { mapState, mapGetters } from "vuex";
import router from "../router";

export default {
  name: "cards",
  components: {
    AddCard
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    ...mapGetters(["isAuthenticated"]),
  },
  data() {
    return {};
  },
  mounted() {
    if (!this.isAuthenticated) {
      router.push("/login");
    }
  },
};
</script>
<style>
.card-view {
  margin-top: 10%;
}
</style>
